export default __webpack_public_path__ + "static/media/mana18.515afc70.svg";